import {IconWrapperIconProps} from "app/Interface/Component/Icons"
import IconWrapper from "app/WebView/Component/icons/icon"
import React from "react"
import CancelIcon from "static/icons/cancel_black_24dp.svg"

const CloseIcon = (props: IconWrapperIconProps) => {
  const name = "close"
  return (
    <IconWrapper name={name} {...props}>
      <CancelIcon/>
    </IconWrapper>
  )
}


export default CloseIcon
